import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HomeModule } from './pages/home/home.module';
import { HttpClientModule } from '@angular/common/http';
import { AppRoutingModule } from './pages/app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LayoutComponent } from './pages/layout/layout.component';
import { MaterialModule } from './core/material/material.module';
import * as CryptoJS from 'crypto-js';
import { DatePipe } from '@angular/common';
import { JWT_OPTIONS, JwtModule } from '@auth0/angular-jwt';
import {  RECAPTCHA_V3_SITE_KEY, RecaptchaV3Module } from 'ng-recaptcha';
import { ConfigFactory, EnvconfigService } from './core/service/envconfig.service';
export function tokenGetter(tokenName: string, keyCaptcha: string) {
  const token = sessionStorage.getItem(tokenName);
  if (token != null) {
    const tokenBytes = CryptoJS.AES.decrypt(token, keyCaptcha);
    return tokenBytes.toString(CryptoJS.enc.Utf8);
  }
  return null;
}
export function jwtConfigFactory(configService: EnvconfigService) {
  return {
    tokenGetter: () => tokenGetter(
      configService.get('TOKEN_NAME'), 
      configService.get('KEY_CAPTCHA')
    )};
}
export function recaptchaFactory(configService: EnvconfigService): string {
  return configService.get('keyCaptcha');
}
@NgModule({
  declarations: [
    AppComponent,
    LayoutComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    MaterialModule,
    HomeModule,
    AppRoutingModule,
    RecaptchaV3Module,
    JwtModule.forRoot({
      jwtOptionsProvider: {
        provide: JWT_OPTIONS,
        useFactory: jwtConfigFactory,
        deps: [EnvconfigService],
      }
    }),
  ],
  providers: [      {
    provide: APP_INITIALIZER,
    useFactory: ConfigFactory,
    deps: [EnvconfigService],
    multi: true
    },
    {
      provide: RECAPTCHA_V3_SITE_KEY,
      useFactory: recaptchaFactory,
      deps: [EnvconfigService] 
    },
    DatePipe,
    EnvconfigService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
